import BaoCaoChiTietCongNoPage from "./BaoCaoChiTietCongNoPage";

export default BaoCaoChiTietCongNoPage